<template>
    <cadastro-simples-form
        endpoint="religiao"
        rota-base="/admin/religiao"
        titulo-singular="Religião"
        :campos-extras='[]'>
    </cadastro-simples-form>
</template>

<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
